import React from 'react'

function Footer() {
  return (

      <footer className="bg-body-tertiary text-center text-lg-start">

  <div className="text-center p-3" style={{backgroundColor:"#c9c9c9",bottom:"0px",position:"absolute",width:"100%"}}>
    © Copyright 2024 : Harsh Prakash - RCCIIT
  </div>

</footer>

  )
}

export default Footer